import type { ThemeOptions } from '@mui/material';
import { createTheme, responsiveFontSizes, ThemeProvider as MuiThemeProvider } from '@mui/material';
import React from 'react';

type Props = { theme: ThemeOptions }

const ThemeProviderContainer = (props: React.PropsWithChildren<Props>) => {
  const { children, theme } = props
  const responseiveTheme = React.useMemo(() => responsiveFontSizes(createTheme(theme)), [theme])
  return (
        <MuiThemeProvider theme={responseiveTheme}>
          {children}
        </MuiThemeProvider>
  )
}

export default ThemeProviderContainer
